module.exports = __webpack_public_path__ + "static/images/txms-rights-interests-bg1.1aad6c4.png";